<div class="hero-banner">
  <app-tenant-hero-image
    class="hero-background"
    worldLeagueImageUrl="/assets/stats-hero.jpg"
  ></app-tenant-hero-image>
  <div class="hero-overlay">
    <div class="hero-content">
      <h1 class="hero-title">{{ title }}</h1>
      <p class="hero-subtitle">{{ subtitle }}</p>
      <nav class="hero-links" aria-label="League quick links">
        <a
          *ngFor="let item of links"
          [routerLink]="item.link"
          [queryParams]="item.queryParams"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          {{ item.label }}
        </a>
      </nav>
    </div>
  </div>
</div>
